import React, { useEffect, useState } from "react";
import { fetchPosts } from "../../api";
import Loader from "../Loader/Loader";
import PostListTemplate from "./templates/PostListTemplate";

function Posts({ type = "posts" }) {
	const [isLoading, setIsLoading] = useState(true);
	const [posts, setPosts] = useState([]);
	const [page, setPage] = useState(1);
	const [perPage, setPerPage] = useState(10);

	useEffect(() => {
		async function getPosts() {
			setIsLoading(true);
			const data = await fetchPosts(page, perPage, type);
			if (data?.length > 0) {
				if (page > 1) {
					setPosts(posts.concat(data));
				} else {
					setPosts(data);
				}
			}
			setIsLoading(false);
		}
		getPosts();
	}, [page, perPage]);

	return (
		<div>
			<div className="row">
				{posts?.map((post, index) => {
					return (
						<PostListTemplate key={index} post={post} type={type} />
					);
				})}
			</div>
			{posts?.length > 0 && !isLoading && (
				<div className="row">
					<div className="col-md-12">
						<button
							style={{ width: "100%" }}
							className="btn btn-block btn-primary"
							onClick={() => setPage((page) => page + 1)}
						>
							Load more
						</button>
					</div>
				</div>
			)}
			{isLoading && <Loader />}
		</div>
	);
}
export default Posts;
